import type React from "react";

import { AIButton } from "@similarweb/ai-kit";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import type { IAIAgentButtonProps } from "./types";

export const AIAgentButton: React.FC<IAIAgentButtonProps> = ({ onClick, label }) => {
    return (
        <AIButton
            onClick={onClick}
            label={label}
            icon={
                <SWReactIcons
                    iconName="sparkles-ai"
                    size="xs"
                    iconColor={colorsPalettes.carbon[0]}
                />
            }
        />
    );
};
